module.exports = __webpack_public_path__ + "assets/376a32bd850e8231af24979b0820d9d4.png";